import React, { Component } from "react";
import Cat from "../Components/Frames/Cat";
import FramesItems from "../Components/Frames/FramesItems";
import {GetProductCount} from '../Helpers/FramesHelpers';
import Constants from '../Config/Config';

const slides = 5;
const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/products.json';

class Frames extends Component {

  constructor(props) {
    super(props);
    this.state = {
      productsLaoded: false,
      slidesToShow: slides,
      error: null,
      frameProducts: [],
      catIncluded: [],
      runAPI: false
    }
  }

  fetchProducts = (category) => {
    var catFinish = false;
    this.setState({ runAPI: true });
    //console.log(this.state.catIncluded)
    if (this.state.catIncluded.length > 0) {
      this.state.catIncluded.some( ( item ) =>
        catFinish = category === item ? true : false
      )
    }
    //console.log(catFinish)
    if (catFinish)
      return;
    var self = this;
    if (this.state.productsLaoded)
      this.setState({productsLaoded: false});
    fetch(URL)
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      //console.log(data, "frames");
      var resultfinal = data;

      resultfinal.sort(function(a, b) {
        return parseFloat(a.dimensions.width) - parseFloat(b.dimensions.width);
      })

      if (slides > resultfinal.length)
        self.setState({ slidesToShow: resultfinal.length })
      else
        self.setState({ slidesToShow: slides });

      self.setState({
        productsLaoded: true,
        frameProducts: resultfinal,
        catIncluded: self.state.catIncluded.concat(category)
      });
      self.dispatchFramesData(resultfinal);
    }, (ex) => {
      self.setState({ error: 'Error' });
    })
  }

  slidesToShow = (count) => {
    ( slides > count ) ? this.setState({ slidesToShow: count }) : this.setState({ slidesToShow: slides });
  };

  dispatchFramesData(FramesData) {
    const data = FramesData;
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        frameProducts: data,
        frameLoading: false
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if ( ('frames' === this.props.selectedTab && !this.state.runAPI) || prevProps.showMeHow !== this.props.showMeHow) {
      this.fetchProducts();
    }
  }

  render() {
    //console.log(this.state.frameProducts)
    return (
      <div className="row">
        <Cat
          {...this.props}
          slidesToShow={this.slidesToShow} />
        <div className="col-sm-9">
          <div className="tit">
            <GetProductCount
              {...this.props}
              allProductCount={this.props.productsCount} />
          </div>
          <FramesItems
            {...this.props}
            productsLaoded={this.state.productsLaoded}
            slidesToShow={this.state.slidesToShow} />
        </div>
      </div>
    );
  }
}
export default Frames;